<div class="po-xl-6 po-lg-6 po-md-12 po-sm-12  ranking-sellers" id="ranking-sellers">
  <po-widget>

    <div class="po-xl-7 po-lg-7 po-md-7 po-sm-7 po-pt-0 po-pl-0">
        <span class="po-font-text-bold">Ranking de vendedores</span>
        <span class="po-ml-1 po-icon po-icon-xml pointer-cursor" [p-tooltip]="topTooltipExcel" (click)="downloadExcel()"></span>
    </div>

    <div class="po-xl-5 po-lg-5 po-md-5 po-sm-5" *ngIf="!loading && !errorApi">
      <po-select name="select" [p-options]="listItem" (p-change)="recoverValues($event)"
        [ngModel]="typeSelected"></po-select>
    </div>
   
   
    <div class="icon-loading" *ngIf="loading && !errorApi">
      <app-loading-icon></app-loading-icon>
    </div>
    <div *ngIf="!loading && errorApi">
      <app-error [message]="message"></app-error>
    </div>

    <div class="po-row">
      <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12" style="overflow: hidden;" *ngIf="!loading && !errorApi">
        <fusioncharts [width]="width" [height]="height" [type]="type" [dataFormat]="dataFormat" [dataSource]="dataSource">
        </fusioncharts>
      </div> 
    </div>

  </po-widget>
</div>